var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tips-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tips-message"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tips-image"},[_c('img',{attrs:{"src":require("@/client/assets/images/tips_light_bulb.svg")}})])
}]

export { render, staticRenderFns }